<label
  for="dropzone-file"
  id="dropzone"
  [class]="
    'flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 ' +
    class
  "
>
  <div class="flex flex-col items-center justify-center pt-5 pb-6">
    <svg
      class="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 16"
    >
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
      />
    </svg>
    <p class="mb-2 text-sm text-gray-500 dark:text-gray-400">
      <span class="font-semibold">{{ 'DASHBOARD.CLICK TO UPLOAD' | translate }}</span>
      {{ 'DASHBOARD.OR DRAG AND DROP' | translate }}
    </p>
    <p class="text-xs text-gray-500 dark:text-gray-400" *ngIf="!fileName || fileName === ''">
      {{ textAccept | translate }}
    </p>
    <p class="text-blue-500 dark:text-blue-400" *ngIf="fileName && fileName !== ''">
      {{ fileName }}
    </p>
    <p class="text-xs text-red-500 dark:text-red-400" *ngIf="errorMsg && errorMsg !== ''">
      {{ errorMsg | translate }}
    </p>
    <button systemButton buttonType="quinary" class="flex items-center gap-3 mt-3" (click)="openWindowFile()">
      <svg
        class="text-white dark:text-white"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-width="1"
          d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
        />
      </svg>
      {{ 'DASHBOARD.BROWSE FILE' | translate }}
    </button>
  </div>
  <input #fileInput id="dropzone-file" type="file" class="hidden" [accept]="accept" (change)="onFileSelected($event)" />
</label>
